/**
 * Wait for a specified number of milliseconds, then resolve
 * @param ms - amount of milliseconds
 * @returns A promise which resolves after "ms" milliseconds
 */
export function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
